module.exports = __webpack_public_path__ + "static/media/VOLT.afa731e2.png";